export default __webpack_public_path__ + "img/cookie-icon-lochmara.f092b68b.svg";